import { WidgetsConfig } from '@sitecore-search/core';
class WidgetFactory {
    constructor() {
        Object.defineProperty(this, "widgets", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
    }
    getWidgetComponentConfig(rfkId, entity) {
        const widgetComponentConfig = WidgetsConfig.get(rfkId, entity);
        if (!widgetComponentConfig || !widgetComponentConfig.type || !widgetComponentConfig.component) {
            return undefined;
        }
        return widgetComponentConfig;
    }
    getWidget(rfkId, entity) {
        if (!this.widgets[rfkId]) {
            const widgetComponentConfig = this.getWidgetComponentConfig(rfkId, entity);
            if (widgetComponentConfig) {
                this.widgets[rfkId] = this.doSetup({ ...widgetComponentConfig, entity }, rfkId);
            }
        }
        return this.widgets[rfkId];
    }
    setup(rfkId, entity) {
        return this.getWidget(rfkId, entity);
    }
}
export default WidgetFactory;
